// frontend/src/components/icons/MongoLeafIcon.tsx
import React from "react";

const MongoLeafIcon: React.FC<{ className?: string; height?: number }> = ({
  className = "",
  height = 28,
}) => {
  // Aspect ratio: width/height = 120/258 ≈ 0.465
  const width = Math.round(height * (120 / 258));
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 258"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M83.0089 28.7559C72.1328 15.9086 62.7673 2.86053 60.8539 0.150554C60.6525 -0.0501848 60.3503 -0.0501848 60.1489 0.150554C58.2355 2.86053 48.8699 15.9086 37.9938 28.7559C-55.3594 147.292 52.6968 227.287 52.6968 227.287L53.6031 227.889C54.4087 240.235 56.4228 258 56.4228 258H60.451H64.4792C64.4792 258 66.4934 240.335 67.299 227.889L68.2052 227.187C68.306 227.187 176.362 147.292 83.0089 28.7559ZM60.451 225.48C60.451 225.48 55.6172 221.365 54.3081 219.257V219.057L60.1489 89.9813C60.1489 89.5798 60.7532 89.5798 60.7532 89.9813L66.594 219.057V219.257C65.2848 221.365 60.451 225.48 60.451 225.48Z" fill="#00684A"/>
    </svg>
  );
};

export default MongoLeafIcon;